import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function userSelectionValidator(arr: any[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (arr?.length && control?.value) {
            return arr.find((x) => x.userId == control?.value?.userId)
                ? null
                : {
                      userSelectionInvalid: true,
                  };
        }
        return;
    };
}
